module.exports = __webpack_public_path__ + "img/banner-1-m.59f6e1a2.jpg";